module.exports = __webpack_public_path__ + "static/media/12OceanBlueAQ5686.adcdd89a.PNG";